import { AutogenModelEdiStopNote, AutogenRowEdiStopNote } from "./autogen/AutogenModelEdiStopNote";

export class ModelEdiStopNote extends AutogenModelEdiStopNote<RowEdiStopNote> {
    constructor() {
        super(RowEdiStopNote);
    }
}

export class RowEdiStopNote extends AutogenRowEdiStopNote {
}